(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskAddQuick',
	};

	var form_id = 'taskaddquick-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var entities = Adzuki.TaskManager.entities;

		Adzuki.TaskManager.initTaskTypeaheads(form_id, false, true);
		Adzuki.TaskManager.initAutoheights();
		Adzuki.TaskManager.initTaskTagFields(form_id);

		// changing the task classification
		$('#' + form_id + 'classification').change(function onClassificationChange(e)
		{
			Adzuki.TaskManager.classificationFieldChange(form_id);
		});

		// when changing the reservation_id, check if there any other
		// reservations or groups linked to it
		$('#' + form_id + 'reservation_id').change(function onReservationIdChange(e)
		{
			var reservation_id = $(this).val();

			if (reservation_id === '') {
				_hideAndUncheckLinkedCheckboxes();
				return;
			}

			Adzuki.TaskManager.getLinkedReservationsAndGroups(reservation_id, form_id, 'task_quick_add');
		});

		// hide reference field if there's a reference chip
		if ($('#task_quick_add .entity-chip').length > 0) {
			$('#task_quick_add .classification-field').addClass('hidden');
		}

		$('#task_quick_add .travel-type-field').addClass('hidden');

		// always hide typeaheads by default
		$.each(entities, function onEachEntity(i, entity) {
			$('#task_quick_add .' + entity + '-typeahead').addClass('hidden');
		});

		// set/unset the save and view flag depending on which button is used for submission
		$('#task_quick_add .save-and-view').off().on('click', function onSaveAndView(e)
		{
			$('#' + form_id + 'view_task').val('1');
		});

		$('#task_quick_add .save-task').off().on('click', function onSave(e)
		{
			$('#' + form_id + 'view_task').val('0');
		});

		// when closing the entity chip
		$('.entity-chip .remove-reference').off().on('click', function onReferenceRemove(e)
		{
			$('#task_quick_add .entity-chip').addClass('hidden');
			$('#task_quick_add .classification-field').removeClass('hidden');

			_hideAndUncheckLinkedCheckboxes();

			// reset classification fields so a new one can be selected
			$('#task_quick_add #' + form_id + 'classification').val('').trigger('change');
		});
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		// redirect to the edit screen?
		if (response['data']['view_task'] === '1') {
			window.location.href = Adzuki.erez_url + Adzuki.base_uri + response['data']['edit_url'];
			return true;
		}

		// just show the Success message and render the form again
		Adzuki.StatusMessage('success', 'The task has been saved.', 'Success', {
			onClose: function onAlertClosed() {
				Adzuki.Ajax.get('/Tasks/addQuick/')
					.then(function viewQuickAddForm(response) {
						$('#top-create_task').html(response);

						Adzuki.Form.initAjaxForm('TaskAddQuick');
					});
			}
		});
	};

	function _hideAndUncheckLinkedCheckboxes()
	{
		$('#task_quick_add .linked-reservations').addClass('hidden');
		$('#task_quick_add .group-reservations').addClass('hidden');

		$('#' + form_id + 'duplicate_linked').prop('checked', false);
		$('#' + form_id + 'duplicate_groups').prop('checked', false);
	}
}(jQuery, window.Adzuki || {}));
